var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z","fill":"#FEFEFE"}})}
var staticRenderFns = []

export { render, staticRenderFns }